<script lang="ts">
	import type { Product } from "../../../core/schema/Product.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import Icon from "./Icon.svelte";

	export let product: Product;
	export let href: string;
	export let detailLabel: string;

	$: mainParameters = product.technicalParameters
		.filter((p) => p.mainOrder !== undefined && p.mainOrder < 2)
		.sort((a, b) => (a.mainOrder ?? 0) - (b.mainOrder ?? 0));
	$: [firstProp, secondProp] = mainParameters;
</script>

<article class="border-lttertiary bg-ltwhiteout group flex flex-col overflow-hidden border">
	<a {href} class="flex flex-1 flex-col" aria-label={product.name}>
		<div class="relative aspect-[538/400] w-full overflow-hidden bg-[#E5E5E5]">
			{#if product.primaryImage}
				<DynamicPicture
					image={product.primaryImage}
					alt={product.name}
					width={538}
					height={400}
					class="absolute inset-0 size-full"
					imgClass="absolute inset-0 size-full object-cover"
					bucket="storage"
				/>
			{/if}
		</div>

		<div class="flex flex-1 flex-col gap-4 p-8">
			<h2
				class="text-ltprimary font-bahnschrift text-2md m-0 p-0 font-medium uppercase leading-[1.3] tracking-[0.02em]"
			>
				{nbspify(product.name)}
			</h2>
			{#if product.subheadline ?? product.perex}
				<p class="text-ltsecondary line-clamp-3 text-xs/[1.6] tracking-wide">
					{nbspify(product.subheadline ?? product.perex)}
				</p>
			{/if}
		</div>
	</a>

	<div class="border-lttertiary border-t">
		{#if firstProp ?? secondProp}
			<dl class="border-lttertiary grid grid-cols-2 border-b">
				{#each [firstProp, secondProp] as prop}
					<div class="border-lttertiary flex flex-col justify-center gap-2 border-r px-8 py-5 last:border-r-0">
						<dt class="text-ltsecondary-100 text-3xs font-normal uppercase tracking-wider">
							{prop ? nbspify(prop.name) : ""}
						</dt>
						<dd class="text-ltprimary-100 font-lexend text-base/[1.6] font-bold">
							{prop ? nbspify(prop.value) : ""}
						</dd>
					</div>
				{/each}
			</dl>
		{/if}

		<div class="px-8 py-6">
			<a
				{href}
				class="text-ltprimary-300 hover:text-ltprimary group/link font-roboto inline-flex items-center gap-2 text-base/none font-medium uppercase tracking-wider transition-colors"
			>
				<span class="relative">
					{detailLabel}
					<span
						class="absolute inset-x-0 -bottom-0.5 h-px origin-left scale-x-0 bg-current transition-transform duration-300 ease-out group-hover/link:scale-x-100"
					></span>
				</span>
				<Icon icon={arrowRight} class="size-3 shrink-0" />
			</a>
		</div>
	</div>
</article>
